var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWarningTriangle28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5921 22.006L14.2085 5.7532C14.1769 5.69847 14.1466 5.67552 14.1224 5.66212C14.0925 5.6455 14.0502 5.6328 14 5.6328C13.9498 5.6328 13.9076 5.6455 13.8776 5.66212C13.8534 5.67552 13.8231 5.69847 13.7915 5.7532L4.40791 22.006C4.37632 22.0608 4.37161 22.0985 4.37209 22.1261C4.37269 22.1604 4.38282 22.2033 4.40791 22.2468C4.43301 22.2903 4.46513 22.3205 4.49451 22.3382C4.51821 22.3524 4.55325 22.3672 4.61644 22.3672H23.3836C23.4468 22.3672 23.4818 22.3524 23.5055 22.3382C23.5349 22.3205 23.567 22.2903 23.5921 22.2468C23.6172 22.2033 23.6273 22.1604 23.6279 22.1261C23.6284 22.0985 23.6237 22.0608 23.5921 22.006ZM16.0853 4.66967C15.1585 3.06445 12.8415 3.06445 11.9148 4.66967L2.5312 20.9225C1.60442 22.5277 2.76289 24.5342 4.61644 24.5342H23.3836C25.2371 24.5342 26.3956 22.5277 25.4688 20.9225L16.0853 4.66967Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7961,
    y: 10.0013,
    width: 2.40783,
    height: 7.82544,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.40783,
    height: 2.23584,
    transform: "matrix(1 0 0 -1 12.7961 21.1805)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangle28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;